import React, { useEffect, useState } from "react";
import "../servicePage.css";
import arLogo from "../Images/AR Services.jpg";
import appDevLogo from "../Images/App development.jpg";
import userManualLogo from "../Images/userManual.jpg";
import customerSatisfactionIcon from "../Images/servicesIcon/customerSatisfaction.png";
import onTimeDeliveryIcon from "../Images/servicesIcon/on_time_delivery.png";
import userFriendlyIcon from "../Images/servicesIcon/user-friendly.png";
import noCompromise from "../Images/servicesIcon/no_compromise.png";
import easyIntegration from "../Images/servicesIcon/integration.png";
import innovativeSolution from "../Images/servicesIcon/solution.png";
import expertDeveloper from "../Images/servicesIcon/expert.png";


const jargonList = [
  { id: 1, name: "Customer Satisfaction", icon: customerSatisfactionIcon, description: "We prioritize our clients' satisfaction and ensure quality deliverables." },
  { id: 2, name: "On-Time Delivery", icon: onTimeDeliveryIcon, description: "We adhere to deadlines to ensure timely delivery of our services." },
  { id: 3, name: "No Compromise on Quality", icon: noCompromise, description: "We maintain high-quality standards in every project we undertake." },
  { id: 4, name: "User-Friendly Interface", icon: userFriendlyIcon, description: "Our solutions are designed to be intuitive and easy to use for all users." },
  { id: 5, name: "Easy Integration", icon: easyIntegration, description: "Our products are designed to seamlessly integrate with existing systems." },
  { id: 6, name: "Innovative Solutions", icon: innovativeSolution, description: "We provide cutting-edge solutions to meet evolving business needs." },
  { id: 7, name: "Expert Developers", icon: expertDeveloper, description: "Our team consists of seasoned professionals who excel in their fields." },
];

const OurServicesPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % jargonList.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      title: "AR-Based User Manuals",
      description: "We create interactive AR-based user manuals that simplify product usage and enhance the learning experience for end users.",
      image: userManualLogo,
    },
    {
      title: "AR Services",
      description: "We offer cutting-edge Augmented Reality (AR) solutions to help businesses enhance their customer experience and streamline processes.",
      image: arLogo,
    },
    {
      title: "App Development",
      description: "Our app development team builds highly efficient, reliable, and scalable applications tailored to meet your business needs.",
      image: appDevLogo,
    },

  ];

  return (
    <div className="services-container">
      <div className="servicesbanner">
        <h2 className="services-heading">Our Services</h2>
        <p className="services-details">
          At Visuar Solutions, we specialize in innovative Augmented Reality (AR) and app development services. From immersive AR experiences to intuitive AR-based user manuals, our solutions are designed to enhance user engagement and streamline business processes.
        </p>
      </div>

      <div className="services-list">
        {services.map((service, index) => (
          <div className={`service-row ${index % 2 === 0 ? "reverse" : ""}`} key={index}>
            <div className="service-image-wrapper">
              <img src={service.image} alt={service.title} className="service-image" />
            </div>
            <div className="service-content">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="jargon-strip">
        <div className="jargon-content">
          {jargonList.map((jargon, index) => (
            <div key={jargon.id} className={`jargon-item ${activeIndex === index ? "active" : ""}`}>
              <img src={jargon.icon} alt={jargon.name} className="jargon-icon" />
              <span className="jargon-name">{jargon.name}</span>
              {activeIndex === index && <p className="jargon-description">{jargon.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurServicesPage;
